<template>
  <BootstrapVueTable
    :title="title"
    :subtitle="subtitle"
    :items="table_data"
    :fields="table_fields" />
</template>

<script>
import axios from 'axios'
import errorRoutingMixin from '@/mixins/errorRoutingMixin'
import data_formats from '@/utils/data_formats'
import BootstrapVueTable from '@/components/BootstrapVueTable'

export default {
  name: 'assigned_rates',
  components: {BootstrapVueTable},
  mixins: [errorRoutingMixin],
  props: ['reference_entity', 'reference_year', 'reference_month'],
  data () {
    return {
      title: "Taux standard et effectifs",
      subtitle: "Cette table présente la taux standard et effectifs des collaborateurs. Ces taux sont utilisés uniquement pour calculer les coûts des mandats." +
                "Le taux effectif est calculé sur la base du salaire, sans aucun overhead.",
      raw_data: [],
      table_data: [],
      table_fields: [],
    }
  },
  watch: {
    all_props () {
      this.load_server_data()
    }
  },
  created () {
    this.load_server_data()
  },
  computed: {
    all_props () {
      return [
        this.reference_entity,
        this.reference_year,
        this.reference_month  
      ]
    },
  },
  methods: {
    load_server_data () {
      if (! this.reference_entity) return  // If user is not yet authenticated. do nothing
      let url = 'webapi/hourly-rates?entity=' + this.reference_entity + '&year=' + this.reference_year + '&month=' + this.reference_month 
      axios.get(url, {headers: {'Authorization': 'Bearer ' + this.$cookies.get('jwt_access')}})
        .then(response => this.raw_data = response.data)
        .then(_ => this.build_table_data())
        .catch(error => {
          console.log(error)
          this.$router.push(this.routeOnError(error.response.status))
        })
    },

    build_table_data() {
      let raw_data = this.raw_data
      raw_data.IsInSIRH = raw_data.IsInSIRH.map(b => b ? 'ok' : '---')
      raw_data.HasAshHours = raw_data.IsInSIRH.map(b => b ? 'ok' : '---')
      raw_data.AverageActivityRate = raw_data.AverageActivityRate.map(r => r*100)
      this.table_data = data_formats.col_to_row_format(raw_data)

      let sortable = {sortable: true}
      let number_format = {formatter: data_formats.number_format_frch_two_decimals, class: 'text-right', ...sortable}
      let number_format_rounded = {formatter: data_formats.number_format_frch_rounded, class: 'text-right', ...sortable}
      let date_format = {formatter: data_formats.date_format_frch_short, class: 'text-left', ...sortable}
      this.table_fields = [{key: 'COLLABORATORNAME', label: 'Nom', ...sortable},
                           {key: 'COLLABORATORFIRSTNAME', label: 'Prénom', ...sortable},
                           {key: 'IsInSIRH', label: 'Dans SIRH', ...sortable},
                           {key: 'HasAshHours', label: 'Heures ASH', ...sortable},
                           {key: 'COLLABORATORCATEGORY', label: 'Cat.'},
                           {key: 'NumberMonths', label: 'Mois', ...sortable},
                           {key: 'AverageActivityRate', label: 'Taux moy.', ...number_format_rounded},
                           {key: 'TotalSalary', label: 'Salaire tot.', ...number_format_rounded},
                           {key: 'STANDARD_RATE', label: 'Taux std.', ...number_format},
                           {key: 'EffectiveRate', label: 'Taux eff.', ...number_format}
      ]
    },
  }
}
</script>